export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-16 overflow-hidden"
    >
      <div className="absolute inset-0 bg-background-50">
        <div className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: 'radial-gradient(circle at 20% 50%, oklch(0.58 0.22 22 / 0.3) 0%, transparent 50%), radial-gradient(circle at 80% 20%, oklch(0.72 0.17 88 / 0.2) 0%, transparent 50%)',
          }}
        />
      </div>

      <div className="relative z-10 w-full mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12 xl:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-8 lg:pt-0">
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-accent-100 text-accent-800 whitespace-nowrap">
                超清播放
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-primary-100 text-primary-700 whitespace-nowrap">
                极速不缓冲
              </span>
              <span className="px-3 py-1 text-xs font-medium rounded-full bg-secondary-100 text-secondary-700 whitespace-nowrap">
                海量资源
              </span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-foreground-950 leading-tight mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              酷客影院
              <span className="block text-2xl md:text-3xl lg:text-4xl font-normal text-foreground-600 mt-2">
                高清电影与电视剧在线观看平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-500 font-light mb-3 italic" style={{ fontFamily: 'var(--font-heading)' }}>
              每一帧，都是视觉盛宴
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              酷客影院汇聚海量高清电影与高清电视剧资源，覆盖院线新片、经典老片、热门剧集与纪录片等多种类型。
              采用超清播放技术，画质细腻、加载流畅不缓冲，为追求极致观影体验的用户打造沉浸式在线观影空间。
              每日持续更新最新热门影视，让好片触手可及。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600" style={{ fontFamily: 'var(--font-heading)' }}>20000+</div>
                <div className="text-xs text-foreground-500 mt-1">高清影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600" style={{ fontFamily: 'var(--font-heading)' }}>每日更新</div>
                <div className="text-xs text-foreground-500 mt-1">50+热门内容</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-700" style={{ fontFamily: 'var(--font-heading)' }}>1080P</div>
                <div className="text-xs text-foreground-500 mt-1">超清画质保障</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观影
              </a>
              <a
                href="#ranking"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 hover:bg-background-200 text-foreground-800 font-medium rounded-lg transition-all text-sm whitespace-nowrap cursor-pointer text-center border border-background-200"
              >
                <i className="ri-fire-line mr-2"></i>浏览热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-md lg:max-w-lg xl:max-w-xl">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-transparent rounded-3xl" />
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20composition%20with%20warm%20deep%20red%20and%20gold%20tones%2C%20soft%20theatrical%20lighting%2C%20film%20texture%20overlay%2C%20elegant%20geometric%20shapes%20reminiscent%20of%20movie%20screens%20and%20projector%20light%20beams%2C%20luxurious%20dark%20atmosphere%20with%20glowing%20highlights%2C%20sophisticated%20art%20deco%20inspired%20elements%2C%20rich%20velvet%20curtain%20textures%2C%20dramatic%20chiaroscuro%20effect%2C%20premium%20entertainment%20brand%20aesthetic&width=1200&height=900&seq=hero-visual-2026&orientation=portrait"
                alt="酷客影院 - 沉浸式观影体验"
                className="relative w-full h-auto rounded-2xl object-cover aspect-[4/3]"
              />
              <div className="absolute -bottom-3 -right-3 bg-background-50 rounded-xl px-4 py-3 border border-background-200/60">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">在线影院热映中</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}